import JoplinHeroSection from "./components/HeroSection";
import JoplinStickyNav from "./components/StickyNav";
import JoplinProcessingTimeSection from "./components/ProcessingTimeSection";
import JoplinServicesSection from "./components/ServicesSection";
import JoplinLocalAreaSection from "./components/LocalAreaSection";
import JoplinTravelTimingSection from "./components/TravelTimingSection";
import JoplinDestinationsSection from "./components/DestinationsSection";
import JoplinTestimonialsSection from "./components/TestimonialsSection";
import JoplinAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import JoplinComparisonSection from "./components/ComparisonSection";
import JoplinMistakesSection from "./components/MistakesSection";
import JoplinHowItWorksSection from "./components/HowItWorksSection";
import JoplinFAQSection, { faqs } from "./components/FAQSection";
import JoplinHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import JoplinFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const faqsMapped = faqs.map((f: { q: string; a: string }) => ({ q: f.q, a: f.a }));

export default function JoplinPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Joplin"
        state="Missouri"
        stateAbbr="MO"
        route="/cities/joplin"
        title="Emergency Passport Joplin, MO — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Joplin, MO — as fast as 24 hours. No 3-hour drive to St. Louis required. A+ BBB rated, registered State Dept. courier serving Tri-State area business travelers, MSSU students, agriculture industry professionals, and families in Jasper and Newton counties."
        geoPlacename="Joplin, Missouri"
        geoPosition="37.0842;-94.5133"
        faqs={faqsMapped}
        servicesSchema={[]}
        statePageName="Missouri"
        statePageRoute="/states/missouri"
      />
      <JoplinHeroSection />
      <JoplinStickyNav />
      <JoplinProcessingTimeSection />
      <JoplinServicesSection />
      <JoplinLocalAreaSection />
      <JoplinTravelTimingSection />
      <JoplinDestinationsSection />
      <JoplinTestimonialsSection />
      <JoplinAcceptanceFacilitiesSection />
      <JoplinComparisonSection />
      <JoplinMistakesSection />
      <JoplinHowItWorksSection />
      <JoplinFAQSection />
      <JoplinHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/joplin" state="MO" />
      <JoplinFinalCTA />
    </div>
  );
}